export default {
  bind(el, binding, vnode) {
    vnode.context.$nextTick(() => {
      const collapse = vnode.context.$refs[binding.value];
      el.$toggle = () => { collapse.toggle(el); };
      el.addEventListener('click', el.$toggle);
    });
  },
  unbind(el) {
    if (el.$toggle) el.removeEventListener('click', el.$toggle);
    delete el.$toggle;
  }
}
